"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SquareOutlined = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var SquareOutlined = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zm14 16V5H5v14h14z", clipRule: "evenodd" })); };
exports.SquareOutlined = SquareOutlined;
//# sourceMappingURL=square-outlined.js.map